import { render } from "./IconPatientsSearch.vue?vue&type=template&id=ba94df40"
import script from "./IconPatientsSearch.vue?vue&type=script&lang=js"
export * from "./IconPatientsSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__